import React from "react";
import { motion } from "framer-motion";
import rect from '../Images/Rectangle4.png'
import icon from '../Images/Icons.png'

const Secthree = () => {

    const slideLeft = {
        initial: { opacity: 0, x: 80 },
        whileInView: { opacity: 1, x: 0 },
        transition: { duration: 0.8 },
        viewport: { once: true }
    };
    const slideRight = {
        initial: { opacity: 0, x: 80 },
        whileInView: { opacity: 1, x: 0 },
        transition: { duration: 0.8 },
        viewport: { once: true }
    };

    return(
        <>
        <div className="container" style={{marginTop: '70px'}}>
            <div className="row">

                <div className="col-md-6">
                    <motion.div {...slideLeft}>
                        <img className="img-fluid" src={rect} alt="" />
                    </motion.div>
                </div>

                <div className="col-md-6">
                    <motion.div {...slideRight}>
                        <h1 style={{fontSize: '35px', fontWeight: '700'}}>
                            Why Enterprises choose Chilicom
                        </h1>

                        <div className="d-flex gap-2 mt-4">
                            <div>
                                <img src={icon} alt="" />
                            </div>
                            <div>
                                <h5>Scalable Architecture</h5>
                                <p>
                                    Our code is built to grow. We ensure your digital assets can handle tomorrow's traffic and data needs.
                                </p>
                            </div>
                        </div>

                        <div className="d-flex gap-2 mt-4">
                            <div>
                                <img src={icon} alt="" />
                            </div>
                            <div>
                                <h5>AI-First Methodology</h5>
                                <p>
                                    We integrate intelligence into every layer, automating the mundane and highlighting the critical.
                                </p>
                            </div>
                        </div>

                        <div className="d-flex gap-2 mt-4">
                            <div>
                                <img src={icon} alt="" />
                            </div>
                            <div>
                                <h5>Security & Compliance</h5>
                                <p>
                                    SOC2 compliant workflows and enterprise-grade security protocols are baked into our delivery process.
                                </p>
                            </div>
                        </div>

                    </motion.div>
                </div>

            </div>
        </div>
        </>
    )
}

export default Secthree;